import React, { type FC } from "react";
import type { ApiSpMovingData } from "@src/businessModules/Stock/api/storePlaces";
import { BusinessDateValue } from "@src/components/business-data-display";
import { DetailList, DetailRow } from "@shared/ui/detail-row";
import "./StockFinishedGoodsReceiptCancelConfirmContent.scss";

/** Поле confirm-контента отмены размещения продукции. */
export interface StockFinishedGoodsReceiptCancelConfirmField {
    /** Подпись поля. */
    label: string;
    /** Значение поля. */
    value?: string | null;
}

/** Пропсы компонента {@link StockFinishedGoodsReceiptCancelConfirmContent}. */
export interface StockFinishedGoodsReceiptCancelConfirmContentProps {
    /** Движение, которое будет удалено при подтверждении. */
    movement: ApiSpMovingData;
    /** Поля контекста строки ВЗН УП. */
    fields: StockFinishedGoodsReceiptCancelConfirmField[];
}

/** Domain-контент confirm для отмены размещения продукции по строке ВЗН УП. */
export const StockFinishedGoodsReceiptCancelConfirmContent: FC<StockFinishedGoodsReceiptCancelConfirmContentProps> = ({
    movement,
    fields,
}) => {
    return (
        <div className="stock_finished_goods_receipt_cancel_confirm_content">
            <p className="stock_finished_goods_receipt_cancel_confirm_content__message">
                Будет удалено последнее движение размещения:
            </p>
            <section
                className="stock_finished_goods_receipt_cancel_confirm_content__section"
                aria-labelledby="stock-fg-receipt-cancel-confirm-details-title"
            >
                <h3
                    id="stock-fg-receipt-cancel-confirm-details-title"
                    className="stock_finished_goods_receipt_cancel_confirm_content__section_title"
                >
                    Движение
                </h3>
                <DetailList
                    layout="tiles"
                    columns="auto"
                    minWidth={80}
                    className="stock_finished_goods_receipt_cancel_confirm_content__details"
                >
                    <DetailRow label="Код движения" value={String(movement.Code)} />
                    <DetailRow label="Количество" value={String(movement.Qty)} />
                    <DetailRow label="Дата" value={<BusinessDateValue value={movement.UserDate} preset="dateTime" />} />
                    {fields.map((row) => (
                        <DetailRow key={row.label} label={row.label} value={row.value ?? "—"} />
                    ))}
                </DetailList>
            </section>
        </div>
    );
};
